import getHrefLangsQuery from '~/diptyqueTheme/customQueries/magento/getHrefLangs';
import { Logger } from '~/helpers/logger';

export function useHreflangs(ctx) {
  const getHrefLangs = async () => {
    const reqPath = ctx?.route?.path || ctx?.path;
    const reqPathParts = reqPath.split('/');
    const path = reqPathParts.slice(2).join('/');
    if (path === undefined) return [];
    // TODO: Fix for the correct one from env when it will be available in env
    const domain = 'https://www.diptyqueparis.com/';

    let hrefLangs: { link: string; language: string }[];

    if (path === '') {
      hrefLangs = [
        { language: 'x-default', link: 'en_eu' },
        { language: 'fr-fr', link: 'fr_fr' },
        { language: 'en-us', link: 'en_us' },
        { language: 'en-gb', link: 'en_uk' },
        { language: 'fr-br', link: 'fr_eu' },
        { language: 'de-de', link: 'de_eu' },
        { language: 'es-es', link: 'es_eu' },
        { language: 'en-nl', link: 'en_eu' },
        { language: 'it-it', link: 'it_eu' },
        { language: 'ja-jp', link: 'ja_jp' },
        { language: 'fr-us', link: 'fr_us' },
        { language: 'zh-hk', link: 'zh_hk' },
        { language: 'en-hk', link: 'en_hk' }
      ];
    } else {
      try {
        const res = await ctx.app.$vsf.$magento.api.customQuery({
          query: getHrefLangsQuery,
          queryVariables: {
            path
          }
        });
        hrefLangs = res?.data?.getHrefLangs || [];
      } catch (error) {
        Logger.error('[useHreflangs]:', error);
        hrefLangs = [];
      }
    }

    return (
      hrefLangs
        .map((item) => {
          return {
            rel: 'alternate',
            hid: 'hl-' + item.language,
            hreflang: item.language,
            href: domain + item.link,
            type: 'text/html'
          };
        })
        .filter((l) => l) || []
    );
  };

  return {
    getHrefLangs
  };
}
